import {
  AuthenticationSource,
  WithUserWebViewProps,
} from '@shopee-user/with-web-view';

export function loginByPasswordWebViewLoginSuccessfully({
  webViewLoginSuccessfully,
  params,
}: {
  webViewLoginSuccessfully: WithUserWebViewProps['webViewLoginSuccessfully'];
  params: {
    nonce?: string;
    fromSource?: AuthenticationSource;
    [key: string]: string | AuthenticationSource | undefined;
  };
}) {
  webViewLoginSuccessfully(params);
}
